import React from "react";
import { Form } from "react-bootstrap";
import { setParam, push, getQueryString, removeParam } from "pages/search/api/filterUrlMaker";
import { _t } from "app/i18n/i18n";
import { isPublicPath } from "lib/routing";
import { AnalystSearchBox } from "./AnalystSearchBox";

export function AnalystFilters() {
  if (isPublicPath()) return null;

  return (
    <Form onChange={onFilterChange} onSubmit={(e) => e.preventDefault()} className="mx-3 pt-2 d-block d-md-none">
      <section className="mb-1 w-100 d-flex flex-nowrap">
        <Form.Control
          as="select"
          name="region"
          size="sm"
          className="mb-1 maxw-250 ml-md-2 mr-2"
          defaultValue={getQueryString().region}
        >
          <option value="">{_t("All Regions")}</option>
          <option value="Americas">{_t("Americas")}</option>
          <option value="EMEA">{_t("EMEA")}</option>
          <option value="Asia ex-Japan">{_t("Asia ex-Japan")}</option>
          <option value="Japan">{_t("Japan")}</option>
        </Form.Control>

        <AnalystSearchBox />
      </section>

      <section className="mb-2 w-100">
        <Form.Control
          as="select"
          name="speciality"
          size="sm"
          className="mb-1"
          defaultValue={getQueryString().speciality}
        >
          <option value="">{_t("All Specialities")}</option>
          <option value="Macro" className="text-primary">
            {_t("All Macro Specialities")}
          </option>
          <option value="Credit">{_t("Credit")} </option>
          <option value="Economics"> {_t("Economics")}</option>
          <option value="Equity Strategy"> {_t("Equity Strategy")}</option>
          <option value="ESG"> {_t("ESG")}</option>
          <option value="FX Strategy"> {_t("FX Strategy")}</option>
          <option value="Macro Strategy"> {_t("Macro Strategy")}</option>
          <option value="Quantitative Strategies"> {_t("Quantitative Strategies")}</option>
          <option value="Rates Strategy"> {_t("Rates Strategy")}</option>
          <option value="Securitized Products"> {_t("Securitized Products")}</option>

          <option value="" disabled />
          <option value="Equity" className="text-primary">
            {_t("All Equity Specialities")}
          </option>
          <option value="Auto &amp; Auto Parts">{_t("Auto & Auto Parts")}</option>
          <option value="Basic Materials">{_t("Basic Materials")}</option>
          <option value="Consumer">{_t("Consumer")}</option>
          <option value="Financials">{_t("Financials")}</option>
          <option value="Healthcare &amp; Pharmaceuticals">{_t("Healthcare & Pharmaceuticals")}</option>
          <option value="Industrials">{_t("Industrials")}</option>
          <option value="Information Technology">{_t("Information Technology")}</option>
          <option value="Energy / Utilities">{_t("Energy / Utilities")}</option>
          <option value="Property">{_t("Property")}</option>
          <option value="Small- &amp; Mid-Cap Stocks">{_t("Small- & Mid-Cap Stocks")}</option>
          <option value="Technology (Electronics)">{_t("Technology (Electronics)")}</option>
        </Form.Control>
      </section>
    </Form>
  );
}

export const onFilterChange = (e) => {
  e.preventDefault();
  const { name, value } = e.target;
  const url = name === "q" ? removeParam("speciality") : undefined;
  push(setParam(name, value.trim(), url));
};
